import Vue from 'vue'
import App from './App.vue'
import router from './router'
//icon图标
import './assets/icon/iconfont.css'
// 轮播图
import "./assets/js/swiper.min.css"
import Viewer from 'v-viewer';
// 中英文
import translate from 'i18n-jsautotranslate'
translate.setUseVersion2() //设置使用v2.x 版本
translate.selectLanguageTag.show = false //是否显示切换栏
translate.listener.start() //监控页面动态渲染的文本进行自动翻译
translate.ignore.class.push('chinese');
Vue.prototype.$translate = translate
 


Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999, // 设置图片预览组件的层级，确保能在其他组件之上
  },
});


// vuex
import store from './store'
// less
import less from 'less'
Vue.use(less)
//jquery
// import $ from 'jquery'
// Vue.use($)


Vue.config.productionTip = false

new Vue({
  router,
  store, 
  render: h => h(App)
}).$mount('#app')
router.beforeEach((to, from, next) => {    
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  next()
  this.$translate.execute() //进行翻译
})
